import './TrackmanParametersTabContent.scss';
import { ParameterModel } from 'types/trackmanParameters';
import ArticlesInfo from '../ArticlesInfo/ArticlesInfo';
import ParameterDefinition from '../ParameterDefinition/ParameterDefinition';
import ParameterVideos from '../ParameterVideos/ParameterVideos';
import TourAveragesTable from '../TourAveragesTable/TourAveragesTable';
import TrackmanParameterImage from '../TrackmanParameterImage/TrackmanParameterImage';
import UsageInfo from '../UsageInfo/UsageInfo';
import { useState } from 'react';

type TrackmanParametersTabContentProps = {
  selectedSubcategoryData: ParameterModel | undefined;
};

export const TrackmanParametersTabContent = ({ selectedSubcategoryData }: TrackmanParametersTabContentProps) => {
  const [visibleVideoUrl, setVisibleVideoUrl] = useState<string>('');
  const visibleVideo =
    selectedSubcategoryData?.videoUrls.find((video) => video.videoUrl === visibleVideoUrl) || selectedSubcategoryData?.videoUrls[0] || null;

  return (
    <div className='trackman-parameters-content'>
      {selectedSubcategoryData && (
        <div className='parameter-content-box'>
          <ParameterDefinition visibleParameter={selectedSubcategoryData} />
          <TrackmanParameterImage visibleParameter={selectedSubcategoryData} />
          <div className='parameter-details'>
            {selectedSubcategoryData.usageInfo && <UsageInfo visibleParameter={selectedSubcategoryData} />}
            {selectedSubcategoryData?.averageTourData && <TourAveragesTable visibleParameter={selectedSubcategoryData} />}
            {visibleVideo && (
              <ParameterVideos
                visibleParameter={selectedSubcategoryData}
                visibleVideo={visibleVideo}
                setVisibleVideo={(v) => setVisibleVideoUrl(v.videoUrl)}
              />
            )}
            {selectedSubcategoryData.articlesInfo && <ArticlesInfo visibleParameter={selectedSubcategoryData} />}
          </div>
        </div>
      )}
    </div>
  );
};
